import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'rock',
      d: 'M-5,-0.5h0.5v0.5h-0.5zM-5,0h1v0.5h-1zM3.5,0h1v0.5h-1zM-4,0.5h3v0.5h-3zM1,0.5h2.5v0.5h-2.5zM-2.5,1h5v0.5h-5z',
    },
    {
      paint: 'frozenWater',
      d: 'M0,-9.5h0.5v0.5h-0.5zM-0.5,-9h0.5v0.5h-0.5zM-1,-8.5h1v4.5h-1zM3,-6.5h0.5v0.5h-0.5zM-4,-6h0.5v0.5h-0.5zM3,-6h1v1h-1zM-3.5,-5.5h0.5v0.5h-0.5zM-3.5,-5h1v0.5h-1zM3,-5h1.5v1h-1.5zM-3.5,-4.5h1.5v2h-1.5zM-0.5,-4h0.5v1h-0.5zM2.5,-4h2v1h-2zM-1,-3h1v3.5h-1zM2.5,-3h1.5v3h-1.5zM-3,-2.5h1v2h-1zM-2.5,-0.5h0.5v1h-0.5zM2.5,0h1v0.5h-1zM-0.5,0.5h0.5v0.5h-0.5zM3.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-2,-10.5h0.5v6.5h-0.5zM-1,-9h0.5v0.5h-0.5zM2.5,-6h0.5v0.5h-0.5zM-4.5,-5.5h1v1h-1zM2,-5.5h1v0.5h-1zM1.5,-5h1.5v1h-1.5zM-5,-4.5h1.5v1h-1.5zM-2,-4h1.5v0.5h-1.5zM1.5,-4h1v1.5h-1zM-5,-3.5h0.5v1h-0.5zM-4,-3.5h0.5v1h-0.5zM-2,-3.5h0.5v0.5h-0.5zM-1,-3.5h0.5v0.5h-0.5zM-2,-3h1v3.5h-1zM-5,-2.5h2v1h-2zM0.5,-2.5h0.5v0.5h-0.5zM2,-2.5h0.5v2.5h-0.5zM-4.5,-1.5h1.5v1h-1.5zM-4.5,-0.5h2v0.5h-2zM-4,0h1.5v0.5h-1.5zM1.5,0h1v0.5h-1zM-1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'ice',
      d: 'M0,-13.5h0.5v1h-0.5zM0,-12.5h1v1.5h-1zM0,-11h1.5v1.5h-1.5zM0.5,-9.5h1v0.5h-1zM0,-9h1.5v1h-1.5zM0,-8h2v3h-2zM0,-5h1.5v2.5h-1.5zM0,-2.5h0.5v0.5h-0.5zM1,-2.5h1v0.5h-1zM0,-2h2v2h-2zM0,0h1.5v0.5h-1.5zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'snowCap',
      d: 'M-0.5,-14h0.5v0.5h-0.5zM-1,-13.5h1v1h-1zM-1.5,-12.5h1.5v1.5h-1.5zM-2,-11h2v0.5h-2zM-1.5,-10.5h1.5v1.5h-1.5zM-1.5,-9h0.5v5h-0.5zM-4.5,-3.5h0.5v1h-0.5zM-1.5,-3.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 349,
};
export const sprites: readonly PixelSprite[] = [variant0];
